<template>
  <div class="card" id="mycard">
    <ReportViewer v-if="reppath" :json_data="jsondata" :reportfilename="filename" :report_url="reppath" />

    <!-- Floating menu -->
    <ul class="fab-menu fab-menu-fixed fab-menu-bottom-right is_stuck" data-fab-toggle="hover">
      <li>
        <button class="fab-menu-btn btn bg-primary-600 btn-float rounded-round btn-icon" @click="showFilterWindow">
          <i class="fab-icon-open icon-filter3"></i>
          <i class="fab-icon-close icon-filter4"></i>
        </button>
      </li>
    </ul>

    <!-- Filter Modal -->
    <vmodal name="filter-window" transition="nice-modal-fade" :delay="100" :resizable="true" :width="575" height="300" @opened="onFilterWindowOpen">
      <form @submit.prevent="loadData">
        <div class="card">
          <div class="card-header header-elements-inline bg-primary p-2">
            <h3 class="card-title">Stock Filters</h3>
          </div>

          <div class="card-body">
            <div class="form-group row">
              <label class="col-md-3 col-form-label">From:</label>
              <div class="col-md-3">
                <input type="date" class="form-control" v-model="from_date" autofocus />
              </div>

              <label class="col-md-3 col-form-label">Upto:</label>
              <div class="col-md-3">
                <input type="date" class="form-control" v-model="upto_date" />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 col-form-label">Quality</label>
              <div class="col-md-9">
                <select class="form-control" v-model.number="quality_id">
                  <option value="0">All</option>
                  <option v-for="q in qualities" :key="q.id" :value="q.id">{{ q.name }}</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-3 col-form-label">Color</label>
              <div class="col-md-9">
                <select class="form-control" v-model.number="color_id">
                  <option value="0">All</option>
                  <option v-for="c in colors" :key="c.id" :value="c.id">{{ c.name }}</option>
                </select>
              </div>
            </div>

            <div class="text-right">
              <button type="submit" class="btn btn-outline alpha-success text-success-800 border-success-600 legitRipple" :disabled="loading">
                Show Report <i class="icon-database-refresh ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </vmodal>

    <!-- Loading Overlay -->
    <div v-if="loading" class="overlay d-flex align-items-center justify-content-center">
      <i class="icon-spinner2 spinner"></i>
    </div>

  </div>
</template>

<script>
import moment from 'moment';
import { userService } from '@/store/auth-header';
import ReportViewer from '@/views/tools/ReportViewerByJson';

export default {
  name: 'Woven_Roll_Stock',
  components: { ReportViewer },
  data() {
    const today = moment().format('YYYY-MM-DD');
    return {
      filename: 'wovenrollstock.mrt',
      reppath: '',
      jsondata: {},
      from_date: today,
      upto_date: today,
      qualities: [],
      colors: [],
      quality_id: 0,
      color_id: 0,
      loading: false,
    };
  },
  mounted() {
    this.showFilterWindow();
    this.loadFilterData();
  },
  computed: {
    reportUrl() {
      return `${process.env.VUE_APP_ROOT_API}api/report/stock/wovenroll?from=${this.from_date}&upto=${this.upto_date}&color=${this.color_id}&quality=${this.quality_id}`;
    },
  },
  methods: {
    showFilterWindow() {
      this.$modal.show('filter-window');
    },
    onFilterWindowOpen() {
      this.reppath = '';
    },
    async loadFilterData() {
      try {
        const headers = userService.authHeader();

        const [qualityRes, colorRes] = await Promise.all([
          fetch(`${process.env.VUE_APP_ROOT_API}api/qualities`, { headers }),
          fetch(`${process.env.VUE_APP_ROOT_API}api/colorcharts`, { headers }),
        ]);

        const [qualityData, colorData] = await Promise.all([
          userService.handleResponse(qualityRes),
          userService.handleResponse(colorRes),
        ]);

        if (qualityData.ok) this.qualities = qualityData.data;
        if (colorData.ok) this.colors = colorData.data;
      } catch (err) {
        swal({ title: 'Error', text: err.toString(), type: 'error' });
      }
    },
    async loadData() {
      this.$modal.hide('filter-window');
      this.loading = true;
      try {
        const res = await fetch(this.reportUrl, {
          method: 'GET',
          headers: userService.authHeader(),
        });

        const resp = await userService.handleResponse(res);
        console.log(JSON.stringify(resp));
        if (resp.ok && resp.data) {
          this.jsondata = resp;
          this.reppath = this.reportUrl;
        } else {
          swal({ title: 'Oops!', text: resp.msg, type: 'error' });
        }
      } catch (err) {
        swal({ title: 'Oh noes!', text: err.toString(), type: 'error' });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
}
</style>
